export const ExportJobStatus = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const

export type ExportJobStatus =
  (typeof ExportJobStatus)[keyof typeof ExportJobStatus]

export const ExportJobStatuses = Object.values(ExportJobStatus)

export function isActiveExportJobStatus(status: ExportJobStatus): boolean {
  return (
    status === ExportJobStatus.PENDING || status === ExportJobStatus.PROCESSING
  )
}
